import React from 'react';
import Datepicker from '../../../forms/Datepicker';
import { msToTime } from '../../../../lib/date.utils';
import Button from '../../../forms/Button';

const DatesSelector = ({ start, end, loading, selectDate, setDates }) => (
    <div className="ckp-admin-lineup-editor-dates-form">
        <div className="ckp-admin-grid-row u-margin-bottom-3">
            <div className="ckp-admin-grid-column">
                <Datepicker
                    maxDate={end ? end : undefined}
                    name={'start'}
                    value={start || msToTime()}
                    onChange={selectDate}
                    label="Start Event"
                />
            </div>
            <div className="ckp-admin-grid-column">
                <Datepicker
                    name={'end'}
                    minDate={start}
                    value={end || msToTime()}
                    disabled={!start}
                    onChange={selectDate}
                    label="End Event"
                />
            </div>
        </div>
        <div className="ckp-admin-grid-row">
            <div className="ckp-admin-grid-column">
                <Button loading={loading} inactive={!start || !end} label="Set event days" onClick={setDates} />
            </div>
        </div>
    </div>
);

export default DatesSelector;
